export interface IAmountButton {
  label: string;
  value: number;
}

export const COUPON_AMOUNT_BUTTONS: IAmountButton[] = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "10",
    value: 10,
  },
  {
    label: "50",
    value: 50,
  },
];

export const COMBINATIONS_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "running", label: "Running" },
  { value: "winner", label: "Winner" },
  { value: "loser", label: "Loser" },
];

export const NUMBER_REGEXP = /^[0-9\b.,]+$/;
export const COUPON_CHECK_STATE_INTERVAL_TIMING = 4000;
export const MY_BETS_INTERVAL_TIMING = 2000;
